import {jsx} from 'panel';

import {PropertyValuesScreenEl} from 'common/widgets/property-filter-menu/property-values-screen';
import {SelectTheme} from 'common/components/select/constants';
import {SelectEl} from 'common/components/select';
import {CommitPropertyFilterEvent} from 'common/widgets/property-filter-menu/property-values-screen/types';

import {FilterValueProps} from '../types';

export function FilterObjectValue({
  filter,
  isActive,
  onSelectMenuChange,
  updateEntry,
  eventNames,
  projectId,
  workspaceId,
  readonly,
  hasNewUI,
}: FilterValueProps) {
  const [, operator, ...labelParts] = filter.getLabelParts();
  const label = [operator.label, ...labelParts.map((part) => part.label)].join(` `);

  return (
    <SelectEl
      class={{
        'is-placeholder': !filter.isValid(),
      }}
      attrs={{
        elref: `filterValueSelect`,
        open: isActive,
        theme: hasNewUI ? SelectTheme.Tertiary : SelectTheme.Select,
        'never-show-caret': true,
        'selected-option': filter.isValid() ? label : `Select value…`,
        readonly,
      }}
      on={{
        menuChange: (ev) => onSelectMenuChange(ev),
      }}
    >
      {isActive && (
        <PropertyValuesScreenEl
          attrs={{
            elref: `filterValue`,
            slot: `body`,
            'display-value-only': true,
            'event-names': eventNames,
            'property-filter': filter.getAttributes(),
            'project-id': projectId,
            'workspace-id': workspaceId,
          }}
          on={{
            commitPropertyFilter: (ev: CommitPropertyFilterEvent) => updateEntry(ev.detail.propertyFilter),
          }}
        />
      )}
    </SelectEl>
  );
}
